import React from 'react';
import { WeaFormItem, WeaCheckbox , WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

class EShowHeader extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            showHeader: this.props.value || '0',
        }
    }

    getSaveValues() {
        return this.state.showHeader;
    }

    render(){
        const { showHeader } = this.state;
        return (
            <WeaFormItem label={getLabel(84582,'是否显示表头') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <div style={{width : '90px', display: 'inline-block', float: 'left'}}>
                    <WeaCheckbox
                        display="switch"
                        value={showHeader}
                        onChange={v => {
                            this.setState({showHeader : v});
                        }}
                        // disabled={disabled}
                    />
                </div>
            </WeaFormItem>
        )
    }
}


export default EShowHeader;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/EShowHeader.js